export const styles = {
  // !py-1/!text-sm: legacy-main.css's unlayered [type='text'] rule forces
  // padding:0.5rem and line-height:1.5rem, which wins over these utilities
  // regardless of specificity and overflows the fixed h-9 box, pushing the
  // text/placeholder off vertical-center. The ! modifier forces !important
  // to reclaim it.
  wizardInputCls:
    "h-9 w-full rounded-md border border-border bg-surface dark:bg-input px-3 !py-1 !text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50",
  wizardTextareaCls:
    "h-16 w-full rounded-md border border-border bg-surface dark:bg-input px-3 py-1 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50",
  wizrdLabelCls: "font-semibold text-text-primary poppins tracking-wider",
  advancedLabelCls:
    "font-semibold text-text-primary poppins tracking-wider text-md",
  wizardErrorCls: "text-sm text-destructive pt-2",
  inputCls:
    "h-9 w-full rounded-md border border-border bg-surface dark:bg-surface px-3 py-1 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50",
  // Editable controls that use the shared shadcn <Input>/<SelectTrigger>
  // default to bg-input/50, which matches the cream page ground and reads as
  // disabled. Give them the white card fill + visible border the leagues
  // custom inputs (inputCls above) already use, so they read as active.
  editableFieldCls: "bg-surface border-border dark:bg-input",
  labelCls: "text-sm font-bold text-text-primary",
  hintCls: "text-xs text-text-muted",
  formRowLabel: "text-sm font-normal text-text-primary poppins pb-3 mt-1",
  inputNumberCls:
    "h-9 w-full monoNumber rounded-md border border-border bg-surface dark:bg-input px-3 py-1 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50",
};
